export const unleashConfig = {
  url: process.env.REACT_APP_UNLEASH_URL ?? '',
  clientKey: process.env.REACT_APP_UNLEASH_CLIENT_KEY ?? '',
  refreshInterval: 3600,
  appName: process.env.REACT_APP_UNLEASH_APP_NAME ?? '',
}
